import React, {useState} from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/AdminLogin.css';

const AdminLogin = () => {
    const [credentials, setCredentials] = useState({email: '', password: ''});
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');

    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setCredentials(prev => ({
          ...prev,
          [name]: value
        }));
      };

    const handleLogin = async(e)=>{
        e.preventDefault();
        setIsLoading(true);
        setError('');
        try {
            const response = await fetch(`${process.env.REACT_APP_URL_SCHEME}${process.env.REACT_APP_IP_ADDRESS}/api/login`,{
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                 email : credentials.email,
                 password : credentials.password
                })
              });
            const data = await response.json();
            if(data?.success){
                localStorage.setItem('admin-auth-token', data.authToken);
                navigate('/admin_panel');
            }
          } catch (err) {
            setError(err.message || 'Login failed. Please try again.');
          } finally {
            setIsLoading(false);
          }
    }
  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <h2>Welcome Back</h2>
          <p>Please enter your credentials to login</p>
        </div>
        {error && <div className="error-message">{error}</div>}
        <form onSubmit={handleLogin}>
          <div className="input-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              name="email"
              value={credentials.email}
              onChange={handleChange}
              placeholder="Enter your email"
              required
            />
            <span className="input-icon">✉️</span>
          </div>
          
          <div className="input-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              name="password"
              value={credentials.password}
              onChange={handleChange}
              placeholder="Enter your password"
              required
            />
            <span className="input-icon">🔒</span>
          </div>
          <button type="submit" className="login-button" disabled={isLoading}>
            {isLoading? <div className='spinner'></div> : 'Login'}
          </button>
        </form>
      </div>
    </div>
  )
}

export default AdminLogin
